import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Translator from "../services/Translator";

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: "grid",
    gridTemplateRows: "38.2%",
    height: "100vh",
  },
  content: {
    display: "flex",
    flexFlow: "column nowrap",
    placeContent: "center",
    placeItems: "center",
    gridRow: 2,
    margin: "0 auto",
    transform: "translateY(-50%)",
    height: "fit-content",
  },
  sorry: {
    fontSize: "6.18rem",
    color: theme.palette.grey[300],
    zIndex: -1,
    margin: 0,
    fontWeight: 900,
    transform: "translate(-38.2%,38.2%)",
  },
}));

export default ({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <div className={classes.content}>
        <p className={classes.sorry}>Sorry</p>
        <p>...we seem to have taken a wrong turn somewhere.</p>
        <Button size="small" color="secondary" variant="contained" href="/">
          {Translator.translate("common.back")}
        </Button>
      </div>
    </div>
  );
};
